import { UAPLPlacementMetaList } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';
import { AdPlacementTypeList, AdPlacementList, TextAdPlacementList } from '@bingads-webui-campaign-react/pmax-landing-ad-preview';

export const commonErrorMsg = _TL_('We can\'t generate ads previews with your business information. The preview shown is a generic representation of ads across Microsoft Advertising Networks.');

export const getAdPlacementList = (imageUrl, errorMessage) => {
  if (errorMessage) {
    return AdPlacementList;
  }
  if (!imageUrl) {
    return TextAdPlacementList;
  }
  return AdPlacementTypeList.map(placementType => ({
    placementMeta: UAPLPlacementMetaList[placementType],
    imageMeta: {
      url: imageUrl,
    },
  }));
};

export const formatAdApiErrors = (errorCode) => {
  let errorMsg = '';
  // currently, set all error to common error message
  switch (errorCode) {
    case 400:
      errorMsg = commonErrorMsg;
      break;
    default:
      errorMsg = commonErrorMsg;
  }

  return errorMsg;
};
